import { supabase } from '@/lib/integrations/supabase'
import { AssetItem } from '../../registrations/types'


// NOTE: Adjust table name/columns to match your database schema
const TABLE = 'assets'
const TABLE_HOLDINGS = 'asset_holdings'

// Lists holdings (stock) for a given asset_key and optional unit
export async function listHoldings(assetKey: string, unitId?: string) {
  let query = supabase.from(TABLE_HOLDINGS).select('*').eq('asset_key', assetKey)
  if (unitId) query = query.eq('unit_id', unitId)
  const { data, error } = await query.order('created_at', { ascending: false })
  if (error) throw error
  return data as AssetItem[]
}

// Backwards-compatible generic list (keeps previous name but queries holdings)
export async function listAssets(assetKey: string, unitId?: string) {
  return listHoldings(assetKey, unitId)
}

export async function createAsset(item: Partial<AssetItem>) {
  const { data, error } = await supabase.from(TABLE).insert([item]).select().single()
  if (error) throw error
  return data as AssetItem
}

export async function updateAsset(id: string, changes: Partial<AssetItem>) {
  const { data, error } = await supabase.from(TABLE).update(changes).eq('id', id).select().single()
  if (error) throw error
  return data as AssetItem
}

export async function deleteAsset(id: string) {
  const { error } = await supabase.from(TABLE).delete().eq('id', id)
  if (error) throw error
  return true
}
